import Api from '../api';
let uri = '/api/ed/idioma';

export const getIdiomas = () => {
    return Api.getInstance().executeGetQuery(`${uri}`)
    .then((resp) => resp.data)
    .catch((error) =>
        console.log(error)
    );
}

export const createIdioma = (data) => {
    return Api.getInstance().executeQuery(uri, data)
    .then(res => res)
    .catch(err => console.log(err));
}

export const editIdioma = (data)  => {
    return Api.getInstance().executeUpdateQuery(uri, data)
    .then(res => res)
    .catch(err => console.log(err));
}




